import { getLocaleWordContent } from '@/utils/language.util';
import React from 'react';
function HistoryItem({ item, no }) {
    return (
        <tr>
            <td>{item.date}</td>
            <td>{item.buy_total}</td>
            <td>{item.sel_total}</td>
        </tr>
    );
}
export default function TableSeven({ history }) {
    return (
        <div className="history_box history_box01 t_pink">
            <div className="table_body">
                <table>
                    <thead>
                        <tr>
                            <th>{getLocaleWordContent('일자')}</th>
                            <th>{getLocaleWordContent('투자금 합계')}</th>
                            <th>{getLocaleWordContent('판매수익합계')}</th>
                        </tr>
                    </thead>
                    <tbody>{history && history?.map((item, index) => <HistoryItem key={index} item={item} />)}</tbody>
                </table>
            </div>
        </div>
    );
}
